































import { Component, Prop, Vue } from 'vue-property-decorator';
import { RealmsModule } from '@/store/modules/realms/realms.store';
import { ApiPermissions } from '@/core/security/Permissions';
import { UpdateRealmNameRequest, Realm } from '@/types/apiServerContract';

@Component
export default class UpdateRealmName extends Vue {
	@Prop({ required: true }) realm!: Realm;

	permissions: string[] = [ApiPermissions.Realm.EditRealmName];
	loading = false;
	realmNameRequest: UpdateRealmNameRequest = {
	    name: '',
	    realmId: -1
	};

	async UpdateRealmName() {
	    const check = await this.$bvModal.msgBoxConfirm('Are you sure you wish to save these changes?', {
	        centered: true,
	        okTitle: 'Yes'
	    });
	    if (!check) return;

	    this.realmNameRequest.realmId = this.realm.id;

	    try {
	        this.loading = true;
	        await RealmsModule.UpdateRealmName(this.realmNameRequest);
	    } finally {
	        this.loading = false;
	    }

	    this.$bvToast.toast('Realm successfully updated', {
	        variant: 'success',
	        title: 'Success'
	    });

	    this.Reset();
	    this.$nextTick(() => {
	        (this.$refs.UpdateRealmName as any).reset();
	    });
	}

	Reset() {
	    this.realmNameRequest = {
	        name: '',
	        realmId: -1
	    };
	}
}
